import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link } from 'gatsby';
import React from 'react';
import { withGw2Theme } from '../../utils/withGw2Theme';

const useStyles = makeStyles()((theme) => ({
  button: {
    borderRadius: '5px 5px 5px 5px',
    backgroundColor: theme.palette.primary.dark,
    '&:hover': { backgroundColor: theme.palette.primary.main },
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
}));

interface Gw2ButtonProps {
  to: string;
  children: React.ReactNode;
}

function GW2Button({ to, children }: Gw2ButtonProps) {
  const { classes } = useStyles();
  return (
    <Button variant="contained" color="primary" className={classes.button}>
      <Link to={to} className={classes.link}>
        {children}
      </Link>
    </Button>
  );
}
export default withGw2Theme()(GW2Button);
